// frontend/src/services/zoneService.js
import api from './api';

const zoneService = {
  // ============================================
  // GET ALL ZONES
  // ============================================
  getAllZones: async () => {
    try {
      const response = await api.get('/companies/zones');
      return response.data;
    } catch (error) {
      console.error('Get zones error:', error);
      throw error;
    }
  },

  // ============================================
  // CREATE ZONE
  // ============================================
  createZone: async (data) => {
    try {
      const response = await api.post('/companies/zones', data);
      return response.data;
    } catch (error) {
      console.error('Create zone error:', error);
      throw error;
    }
  },

  // ============================================
  // UPDATE ZONE
  // ============================================
  updateZone: async (id, data) => {
    try {
      const response = await api.put(`/companies/zones/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Update zone error:', error);
      throw error;
    }
  },

  // ============================================
  // DELETE ZONE
  // ============================================
  deleteZone: async (id) => {
    try {
      const response = await api.delete(`/companies/zones/${id}`);
      return response.data;
    } catch (error) {
      console.error('Delete zone error:', error);
      throw error;
    }
  }
};

export default zoneService;